// components/steps/StepAdditionalDescription.jsx
import React, { useState, useEffect } from 'react';

const StepAdditionalDescription = ({ data, updateData, skip, goBack }) => {
  const [text, setText] = useState(data.additionalDescription || '');

  // Sync when navigating back
  useEffect(() => {
    setText(data.additionalDescription || '');
  }, [data.additionalDescription]);

  const isNextDisabled = text.trim().length === 0;

  const handleNext = () => {
    updateData('additionalDescription', text.trim());
  };

  return (
    <div className="bg-white/60 backdrop-blur p-6 rounded-xl shadow-lg max-w-md mx-auto">
      <h2 className="text-xl font-semibold mb-4 text-center">
        Any additional details you’d like to share?
      </h2>

      <textarea
        className="w-full h-32 p-3 border rounded-lg mb-6 focus:outline-none"
        placeholder="e.g., I prefer afternoon tours, need wheelchair access…"
        value={text}
        onChange={e => setText(e.target.value)}
      />

      {/* Navigation */}
      <div className="flex justify-between items-center">
        {goBack ? (
          <button
            onClick={goBack}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition"
          >
            Back
          </button>
        ) : (
          <div />
        )}
        <div className="flex items-center gap-2">
          <button
            onClick={handleNext}
            disabled={isNextDisabled}
            className={`px-6 py-2 rounded-lg transition 
              ${isNextDisabled
                ? 'bg-blue-300 text-white cursor-not-allowed'
                : 'bg-blue-600 text-white hover:bg-blue-700'}`}
          >
            Next
          </button>
          <button
            onClick={skip}
            className="px-6 py-2 bg-transparent border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-100 transition"
          >
            Skip
          </button>
        </div>
      </div>
    </div>
  );
};

export default StepAdditionalDescription;
